import { Companion_getInstance1bxbth0yni76u as Companion_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/uuid/Uuid.mjs';
import {
  toNotBlankString1ovj48s0kinvm as toNotBlankString,
  NotBlankString__toString_impl_5tex9r2ig2s5isyc5ve as NotBlankString__toString_impl_5tex9r,
  NotBlankString__hashCode_impl_fxqzj41ooh7w2aare6h as NotBlankString__hashCode_impl_fxqzj4,
} from '../../../../../../types-types/kotools/types/text/NotBlankString.mjs';
import {
  throwOnFailure24snjmtlqgzo8 as throwOnFailure,
  _Result___get_value__impl__bjfvqg316j9v81zgqwq as _Result___get_value__impl__bjfvqg,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PinTarget_Pair_getInstance9mdjrg2qoqie as PinTarget_Pair_getInstance } from './PinTarget.mjs';
import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      p2a() {
        // Inline function 'kotlin.getOrThrow' call
        var this_0 = toNotBlankString(Companion_getInstance().vt().toString());
        throwOnFailure(this_0);
        var tmp$ret$0 = _Result___get_value__impl__bjfvqg(this_0).o29_1;
        return new (PinId())(tmp$ret$0);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  return Companion_instance;
}
var PinIdClass;
function PinId() {
  if (PinIdClass === VOID) {
    class $ {
      constructor(value) {
        this.d2e_1 = value;
      }
      toString() {
        return 'PinId(value=' + NotBlankString__toString_impl_5tex9r(this.d2e_1) + ')';
      }
      hashCode() {
        return NotBlankString__hashCode_impl_fxqzj4(this.d2e_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PinId()))
          return false;
        if (!(this.d2e_1 === other.d2e_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'PinId');
    PinIdClass = $;
  }
  return PinIdClass;
}
var PinClass;
function Pin() {
  if (PinClass === VOID) {
    class $ {
      constructor(id, name, icon, target) {
        name = name === VOID ? '' : name;
        icon = icon === VOID ? '' : icon;
        target = target === VOID ? PinTarget_Pair_getInstance() : target;
        this.e2e_1 = id;
        this.f2e_1 = name;
        this.g2e_1 = icon;
        this.h2e_1 = target;
      }
      i2e(id, name, icon, target) {
        return new (Pin())(id, name, icon, target);
      }
      j2e(id, name, icon, target, $super) {
        id = id === VOID ? this.e2e_1 : id;
        name = name === VOID ? this.f2e_1 : name;
        icon = icon === VOID ? this.g2e_1 : icon;
        target = target === VOID ? this.h2e_1 : target;
        return $super === VOID ? this.i2e(id, name, icon, target) : $super.i2e.call(this, id, name, icon, target);
      }
      toString() {
        return 'Pin(id=' + this.e2e_1.toString() + ', name=' + this.f2e_1 + ', icon=' + this.g2e_1 + ', target=' + this.h2e_1.toString() + ')';
      }
      hashCode() {
        var result = this.e2e_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.f2e_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.g2e_1) | 0;
        result = imul(result, 31) + this.h2e_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Pin()))
          return false;
        if (!this.e2e_1.equals(other.e2e_1))
          return false;
        if (!(this.f2e_1 === other.f2e_1))
          return false;
        if (!(this.g2e_1 === other.g2e_1))
          return false;
        if (!this.h2e_1.equals(other.h2e_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Pin');
    PinClass = $;
  }
  return PinClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  PinId as PinId3lhhfdu3qni8f,
  Pin as Pin34ndi4qc5y3vu,
  Companion_instance as Companion_instance2noacoj032wzr,
};
//endregion

//# sourceMappingURL=Pin.mjs.map
